<section id="user-info">
	<div>
		<mat-icon svgIcon="sanus-person-blue"></mat-icon>
		<h2>
			{{ beneficiary.name || nullPlaceholder }}
		</h2>
	</div>
</section>

<main>
	<section class="table">
		<table mat-table matSort [dataSource]="isLoading ? [] : tableData">
			<ng-container matColumnDef="actionType">
				<th *matHeaderCellDef mat-header-cell>Tipo de Movimentação</th>
				<td *matCellDef="let element" mat-cell>
					{{ capitalize(element.actionType) }}
				</td>
			</ng-container>

			<ng-container matColumnDef="description">
				<th *matHeaderCellDef mat-header-cell>Descrição</th>
				<td *matCellDef="let element" mat-cell>
					{{ element.description }}
				</td>
			</ng-container>

			<ng-container matColumnDef="validityBeginning">
				<th *matHeaderCellDef mat-header-cell>Início de Vigência</th>
				<td *matCellDef="let element" mat-cell>
					{{
						(element.validityBeginning | date: 'dd/MM/YYYY') || nullPlaceholder
					}}
				</td>
			</ng-container>

			<ng-container matColumnDef="validityEnding">
				<th *matHeaderCellDef mat-header-cell>Fim de Vigência</th>
				<td *matCellDef="let element" mat-cell>
					{{ (element.validityEnding | date: 'dd/MM/YYYY') || nullPlaceholder }}
				</td>
			</ng-container>

			<ng-container matColumnDef="permanencyDate">
				<th *matHeaderCellDef mat-header-cell>Permanência</th>
				<td *matCellDef="let element" mat-cell>
					{{ (element.permanencyDate | date: 'dd/MM/YYYY') || nullPlaceholder }}
				</td>
			</ng-container>

			<ng-container matColumnDef="responsibleUser">
				<th *matHeaderCellDef mat-header-cell>Responsável</th>
				<td *matCellDef="let element" mat-cell>
					{{ element.responsibleUser || nullPlaceholder }}
				</td>
			</ng-container>

			<ng-container matColumnDef="actionDate">
				<th *matHeaderCellDef mat-header-cell>Ocorrência</th>
				<td *matCellDef="let element" mat-cell class="text-wrap-nowrap">
					{{
						element.actionDate
							? (element.actionDate | date: 'dd/MM/yyyy HH:mm') + 'h'
							: nullPlaceholder
					}}
				</td>
			</ng-container>

			<tr *matHeaderRowDef="tableColumns" mat-header-row></tr>
			<tr *matRowDef="let row; columns: tableColumns" mat-row></tr>
		</table>

		<span id="not-found" *ngIf="!isLoading && !tableData.filteredData.length">
			Não foram encontradas movimentações desse usuário
		</span>

		<div id="spinner" *ngIf="isLoading">
			<mat-spinner diameter="20"></mat-spinner>
		</div>
	</section>
</main>
